
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { isMobile } from '@/utils/validate';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class  extends Vue {
  public advList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            title: '舒适房间',
            desc: '每人一张3尺床铺，配备书桌、椅子、衣柜及独立冰箱，房间内设空调和独立卫浴间。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/hk_feature1.jpg'),
        },
        {
            id: 2,
            title: '共享厨房',
            desc: '每层设有Pantry及简易厨房，配备两个灶台及冰箱，满足日常烹饪需求。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/hk_feature2.jpg'),
        },
        {
            id: 3,
            title: '洗衣设备',
            desc: '每层设一部洗衣机及烘干机，天台额外配备三部，共六部洗衣机满足住户需求。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/hk_feature3.jpg'),
        },
        {
            id: 4,
            title: '公共空间',
            desc: '每层均设有共享生活空间，天台开放区域可供聚会、休憩及娱乐活动使用。',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/hk_feature4.jpg'),
        },
        {
            id: 5,
            title: '全年维修',
            desc: '无论何时宿舍内出现问题，专业团队随时待命，确保学生的生活环境始终舒适、安全与无忧，全心投入学业。',
            icon: require('@/assets/image/common/feature_icon_maintenance.png'),
            img: require('@/assets/image/common/hk_feature5.jpg'),
        },
        {
            id: 6,
            title: '每天清洁',
            desc: '维持环境卫生与舒适度，为学生提供一个干净、安全的居住空间，让他们能安心学习，专注于自己的学业与生活。',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/hk_feature6.jpg'),
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            title: '舒適房間',
            desc: '每人一張3呎床鋪，配備書桌、椅子、衣櫥及獨立冰箱，房間內設冷氣和獨立衛浴間。',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/hk_feature1.jpg'),
        },
        {
            id: 2,
            title: '共享廚房',
            desc: '每層設有Pantry及簡易廚房，配備兩個灶台及冰箱，滿足日常烹飪需求。',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/hk_feature2.jpg'),
        },
        {
            id: 3,
            title: '洗衣設備',
            desc: '每層設一部洗衣機及烘乾機，天台額外配備三部，共六部洗衣機滿足住戶需求。',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/hk_feature3.jpg'),
        },
        {
            id: 4,
            title: '公共空間',
            desc: '每層均設有共享生活空間，天台開放區域可供聚會、休憩及娛樂活動使用。',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/hk_feature4.jpg'),
        },
        {
            id: 5,
            title: '全年維修',
            desc: '無論何時宿舍內出現問題，專業團隊隨時待命，確保學生的生活環境始終舒適、安全與無憂，全心投入學業。',
            icon: require('@/assets/image/common/feature_icon_maintenance.png'),
            img: require('@/assets/image/common/hk_feature5.jpg'),
        },
        {
            id: 6,
            title: '每天清潔',
            desc: '維持環境衛生與舒適度，為學生提供一個乾淨、安全的居住空間，讓他們能安心學習，專注於自己的學業與生活。',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/hk_feature6.jpg'),
        }
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            title: 'Comfortable room',
            desc: 'Each person has a 3-foot bed, equipped with a desk, chair, wardrobe and independent refrigerator. The room is equipped with air conditioning and independent bathroom. ',
            icon: require('@/assets/image/common/feature_icon_room.png'),
            img: require('@/assets/image/common/hk_feature1.jpg'),
        },
        {
            id: 2,
            title: 'Shared Kitchen',
            desc: 'Each floor has a Pantry and a simple kitchen, equipped with two stoves and a refrigerator to meet daily cooking needs.',
            icon: require('@/assets/image/common/feature_icon_kitchen.png'),
            img: require('@/assets/image/common/hk_feature2.jpg'),
        },
        {
            id: 3,
            title: 'Laundry facilities',
            desc: 'Each floor is equipped with a washing machine and dryer, and the rooftop is equipped with three more, for a total of six washing machines to meet the needs of residents.',
            icon: require('@/assets/image/common/feature_icon_laundry.png'),
            img: require('@/assets/image/common/hk_feature3.jpg'),
        },
        {
            id: 4,
            title: 'Public Space',
            desc: 'Each floor has a shared living space, and the rooftop open area can be used for gatherings, rest and entertainment activities. ',
            icon: require('@/assets/image/common/feature_icon_public.png'),
            img: require('@/assets/image/common/hk_feature4.jpg'),
        },
        {
            id: 5,
            title: 'Maintenance all year round',
            desc: 'Whenever there is a problem in the dormitory, the professional team is on standby to ensure that students always have a comfortable, safe and worry-free living environment so that they can devote themselves to their studies. ',
            icon: require('@/assets/image/common/feature_icon_maintenance.png'),
            img: require('@/assets/image/common/hk_feature5.jpg'),
        },
        {
            id: 6,
            title: 'Daily Cleaning',
            desc: 'Maintain environmental hygiene and comfort, and provide students with a clean and safe living space so that they can study with peace of mind and focus on their studies and life.',
            icon: require('@/assets/image/common/feature_icon_clean.png'),
            img: require('@/assets/image/common/hk_feature6.jpg'),
        }
      ]
    }
  ];
  public roomTypeFloorPlanList = [
    {
      id: 1,
      name: '1房',
      videoUrl: require('@/assets/image/common/hk_3F RM1.mp4'),
    },
    {
      id: 2,
      name: '2房',
      videoUrl: require('@/assets/image/common/hk_3F RM2.mp4'),
    },
    {
      id: 3,
      name: '3房',
      videoUrl: require('@/assets/image/common/hk_3F RM3.mp4'),
    },
    {
      id: 4,
      name: '4房',
      videoUrl: require('@/assets/image/common/hk_3F RM4.mp4'),
    },
    {
      id: 5,
      name: '5房',
      videoUrl: require('@/assets/image/common/hk_3F RM5.mp4'),
    },
    {
      id: 6,
      name: '6房',
      videoUrl: require('@/assets/image/common/hk_3F RM6.mp4'),
    },
    {
      id: 7,
      name: '7房',
      videoUrl: require('@/assets/image/common/hk_3F RM7.mp4'),
    }
  ]
  public roomTypeList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            roomType: '单人房',
            desc: '精致单人空间，独立卫浴，共享客厅226尺',
            roomSize: '120呎',
            roomHeight: '3.2米层高',
            roomPeople: '1人',
            roomPrice: '$9,500起/每人',
            roomList : [
              {
                id: 3,
                name: '3房',
                videoUrl: require('@/assets/image/common/hk_3F RM3.mp4'),
              },
              {
                id: 4,
                name: '4房',
                videoUrl: require('@/assets/image/common/hk_3F RM4.mp4'),
              },
              {
                id: 5,
                name: '5房',
                videoUrl: require('@/assets/image/common/hk_3F RM5.mp4'),
              },
              {
                id: 6,
                name: '6房',
                videoUrl: require('@/assets/image/common/hk_3F RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room3.jpg'),
        },
        
        {
            id: 2,
            roomType: '双人房',
            desc: '舒适双人房型，配备独立卫浴，共享客厅226尺',
            roomSize: '180呎',
            roomHeight: '3.2米层高',
            roomPeople: '2人',
            roomPrice: '$8,000起/每人',
            roomList : [
              {
                id: 1,
                name: '1房',
                videoUrl: require('@/assets/image/common/hk_3F RM1.mp4'),
              },
              {
                id: 2,
                name: '2房',
                videoUrl: require('@/assets/image/common/hk_3F RM2.mp4'),
              },
              {
                id: 7,
                name: '7房',
                videoUrl: require('@/assets/image/common/hk_3F RM7.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room2.jpg'),
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            roomType: '單人房',
            desc: '精緻單人空間，獨立衛浴，共享客廳226呎',
            roomSize: '120呎',
            roomHeight: '3.2米層高',
            roomPeople: '1人',
            roomPrice: '$9,500起/每人',
            roomList : [
              {
                id: 3,
                name: '3房',
                videoUrl: require('@/assets/image/common/hk_3F RM3.mp4'),
              },
              {
                id: 4,
                name: '4房',
                videoUrl: require('@/assets/image/common/hk_3F RM4.mp4'),
              },
              {
                id: 5,
                name: '5房',
                videoUrl: require('@/assets/image/common/hk_3F RM5.mp4'),
              },
              {
                id: 6,
                name: '6房',
                videoUrl: require('@/assets/image/common/hk_3F RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room3.jpg'),
        },
        {
            id: 2,
            roomType: '雙人房',
            desc: '舒適雙人房型，配備獨立衛浴，共享客廳226呎',
            roomSize: '180呎',
            roomHeight: '3.2米層高',
            roomPeople: '2人',
            roomPrice: '$8,000起/每人',
            roomList : [
              {
                id: 1,
                name: '1房',
                videoUrl: require('@/assets/image/common/hk_3F RM1.mp4'),
              },
              {
                id: 2,
                name: '2房',
                videoUrl: require('@/assets/image/common/hk_3F RM2.mp4'),
              },
              {
                id: 7,
                name: '7房',
                videoUrl: require('@/assets/image/common/hk_3F RM7.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room2.jpg'),
        }
      ]
    },
    {
      lang: 'en-us',
      data: [
        // {
        //     id: 1,
        //     roomType: 'Single',
        //     desc: 'Exquisite single space, private bathroom, shared living room 226 square feet',
        //     roomSize: '120 feet',
        //     roomHeight: '3.2 height',
        //     roomPeople: '1 person',
        //     roomPrice: '$9,500/person',
        //     roomList : [
        //       {
        //         id: 3,
        //         name: 'Room 3',
        //         videoUrl: require('@/assets/image/common/hk_3F RM3.mp4'),
        //       },
        //       {
        //         id: 4,
        //         name: 'Room 4',
        //         videoUrl: require('@/assets/image/common/hk_3F RM4.mp4'),
        //       },
        //       {
        //         id: 5,
        //         name: 'Room 5',
        //         videoUrl: require('@/assets/image/common/hk_3F RM5.mp4'),
        //       },
        //       {
        //         id: 6,
        //         name: 'Room 6',
        //         videoUrl: require('@/assets/image/common/hk_3F RM6.mp4'),
        //       }
        //     ],
        //     features: [],
        //     img: require('@/assets/image/common/hk_room3.jpg'),
        // },
         {
            id: 1,
            roomType: 'Single',
            desc: 'Exquisite single space, private bathroom, shared living room 226 square feet',
            roomSize: '120 feet',
            roomHeight: '3.2 height',
            roomPeople: '1 person',
            roomPrice: 'From $9,500/person',
            roomList : [
              {
                id: 3,
                name: 'Room 3',
                videoUrl: require('@/assets/image/common/hk_3F RM3.mp4'),
              },
              {
                id: 4,
                name: 'Room 4',
                videoUrl: require('@/assets/image/common/hk_3F RM4.mp4'),
              },
              {
                id: 5,
                name: 'Room 5',
                videoUrl: require('@/assets/image/common/hk_3F RM5.mp4'),
              },
              {
                id: 6,
                name: 'Room 6',
                videoUrl: require('@/assets/image/common/hk_3F RM6.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room3.jpg'),
        },
        {
            id: 2,
            roomType: 'Double',
            desc: 'Comfortable double room, equipped with private bathroom, shared living room 226 feet',
            roomSize: '180 feet',
            roomHeight: '3.2 height',
            roomPeople: '2 persons',
            roomPrice: 'From $8,000/person',
            roomList : [
              {
                id: 1,
                name: 'Room 1',
                videoUrl: require('@/assets/image/common/hk_3F RM1.mp4'),
              },
              {
                id: 2,
                name: 'Room 2',
                videoUrl: require('@/assets/image/common/hk_3F RM2.mp4'),
              },
              {
                id: 7,
                name: 'Room 7',
                videoUrl: require('@/assets/image/common/hk_3F RM7.mp4'),
              }
            ],
            features: [],
            img: require('@/assets/image/common/hk_room2.jpg'),
        }
      ]
    }
  ]
  public locationList = [
    {
      lang: 'zh',
      data: [
        {
            id: 1,
            university: '香港理工大学',
            time: '约10分钟',
        },
        {
            id: 2,
            university: '香港都会大学',
            time: '约12分钟',
        },
        {
            id: 3,
            university: '香港城市大学',
            time: '约26分钟',
        },
        {
            id: 4,
            university: '香港浸会大学',
            time: '约35分钟',
        },
        {
            id: 5,
            university: '香港大学',
            time: '约40分钟',
        },
        {
            id: 6,
            university: '香港中文大学',
            time: '约50分钟',
        },
        {
            id: 7,
            university: '香港科技大学',
            time: '约60分钟',
        }
      ]
    },
    {
      lang: 'zh-hk',
      data: [
        {
            id: 1,
            university: '香港理工大學',
            time: '約10分鐘',
        },
        {
            id: 2,
            university: '香港都會大學',
            time: '約12分鐘',
        },
        {
            id: 3,
            university: '香港城市大學',
            time: '約26分鐘',
        },
        {
            id: 4,
            university: '香港浸會大學',
            time: '約35分鐘',
        },
        {
            id: 5,
            university: '香港大學',
            time: '約40分鐘',
        },
        {
            id: 6,
            university: '香港中文大學',
            time: '約50分鐘',
        },
        {
            id: 7,
            university: '香港科技大學',
            time: '約60分鐘',
        }
      ]
    },
    {
      lang: 'en-us',
      data: [
        {
            id: 1,
            university: 'Hong Kong Polytechnic University',
            time: 'About 10 minutes',
        },
        {
            id: 2,
            university: 'Hong Kong Metropolitan University',
            time: 'About 12 minutes',
        },
        {
            id: 3,
            university: 'City University of Hong Kong',
            time: 'About 26 minutes',
        },
        {
            id: 4,
            university: 'Hong Kong Baptist University',
            time: 'About 35 minutes',
        },
        {
            id: 5,
            university: 'The University of Hong Kong',
            time: 'About 40 minutes',
        },
        {
            id: 6,
            university: 'The Chinese University of Hong Kong',
            time: 'About 50 minutes',
        },
        {
            id: 7,
            university: 'The Hong Kong University of Science and Technology',
            time: 'About 60 minutes',
        }
      ]
    }
  ]
  public locationDescList = [
    {
      lang: 'zh',
      desc1: '步行5分钟可达黄埔站（观塘线）、何文田站（观塘线）、红磡站（东铁线）',
      desc2: '公寓正对巴士站，直达旺角、尖沙咀、沙田等主要地区',
      desc3: ''
    },
    {
      lang: 'zh-hk',
      desc1: '步行5分鐘可達黃埔站（觀塘線）、何文田站（觀塘線）、紅磡站（東鐵線）',
      desc2: '公寓正對巴士站，直達旺角、尖沙咀、沙田等主要地區',
      desc3: ''
    },
    {
      lang: 'en-us',
      desc1: '5-minute walk to Whampoa Station (Kwun Tong Line), Ho Man Tin Station (Kwun Tong Line), Hung Hom Station (East Rail Line)',
      desc2: 'The apartment is directly opposite the bus stop, directly connected to major areas such as Mong Kok, Tsim Sha Tsui, Shatin, etc.',
      desc3: ''
    },
  ]

  public feeDescList = [
    {
      lang: 'zh',
      desc1: '每月水电煤气费用账单将张贴于宿舍群组，供住户查阅，每层各室室友按人数及用量分摊费用。',
      desc2: '所有费用将于退租时，从押金中扣除并与房租押金一并结算并退还。'
    },
    {
      lang: 'zh-hk',
      desc1: '每月水電煤氣費用賬單將張貼於宿舍群組，供住戶查閱，每层各室室友按人數及用量分攤費用。',
      desc2: '所有費用將於退租時，從押金中扣除並與房租押金一併結算並退還。'
    },
    {
      lang: 'en-us',
      desc1: 'The monthly water, electricity, and gas bills will be posted in the dormitory group for residents to view, and roommates on each floor will share the fees according to the number of people and usage. ',
      desc2: 'All fees will be deducted from the deposit and settled and refunded together with the rent deposit when you move out. '
    }
  ]

  public contactInfo = [
    {
      lang: 'zh',
      address: '香港红磡芜湖街32号',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    },
    {
      lang: 'zh-hk',
      address: '香港紅磡蕪湖街32號',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    },
    {
      lang: 'en-us',
      address: '32 Wuhu Street, Hung Hom, Hong Kong',
      phone: '+852 2110 3835',
      email: 'info@prestige32.com'
    }
  ]
  public showRoomListVisit = false;
  public showRoomVisit = false;
  public roomList = [];
  public roomSelected = 0;
  public roomVideo = '';

  get langEN() {
      if (AppModule.language === 'en-us') {
          return true;
      } else {
          return false;
      }
  }
  get isMobile() {
    return isMobile();
  }
  public getAdvList() {
    return this.advList.find((item: any)=>item.lang === AppModule.language)?.data;
  }

  public getRoomTypeList() {
    return this.roomTypeList.find((item: any)=>item.lang === AppModule.language)?.data;
  }

  public getLocationList() {
    return this.locationList.find((item: any)=>item.lang === AppModule.language)?.data;
  }

  public getLocationDescList() {
    return this.locationDescList.find((item: any)=>item.lang === AppModule.language);
  }

  public getFeeDescList() {
    if (this.feeDescList.length > 0) {
        return this.feeDescList.find((item: any)=>item.lang === AppModule.language);
    }
    return null;
  }

  public getContactInfo() {
    return this.contactInfo.find((item: any)=>item.lang === AppModule.language);
  }

  public mounted() {
    const roomTypeData = this.roomTypeList.find((item: any)=>item.lang === AppModule.language)?.data;
    if (roomTypeData) {
      this.roomSelected = roomTypeData[0].roomList[0].id;
      this.roomVideo = roomTypeData[0].roomList[0].videoUrl;
    }
  }

  public goRoomListVisit(item: any) {
    this.showRoomListVisit = true;
    this.roomList = item.roomList;
  }
  public closeRoomListVisit() {
    this.showRoomListVisit = false;
  }
  public setRoomVideo(item: any) {
    this.roomVideo = item.videoUrl;
    this.roomSelected = item.id;
  }
  public closeRoomVisit() {
    this.showRoomVisit = false;
  }
  public setRoomVideoById(id: number) {
    this.showRoomVisit = true;
    this.roomVideo = this.roomTypeFloorPlanList[id-1].videoUrl;
    this.roomSelected = id;
  }
}
